// extracted by mini-css-extract-plugin
export default {"panel":"cluster-panel_panel__hA4ee"};